export class SurveyAnswer {
    constructor(_data) {
        this.id = _data.id || 0;
        this.question_id = _data.question_id || 0;
        this.survey_id = _data.survey_id || 0;
        this.type = _data.type || '';
        this.answer_json = _data.answer_json || {};
    }
}
